import React from 'react';

declare const window: any;
declare const document: any;

const NewsroomItem: React.FunctionComponent<any> = ({data}) => {
  if ( window.location !== window.parent.location ) {
    // The page is in an iframe
    console.log('iframe');
  } else {
    // The page is not in an iframe
    console.log('no iframe');
  }

  // const goToArticle = () => {
  //   window.parent.location.href = document.referrer + "/oral-history" + data.link_to_oral_history;
  // }

  return (
    <div className="history p-4 border border-maf-green mb-6">
      <h3 className="font-bruno text-base mt-0 mb-4">{data.name_of_person}</h3>
      <a href={document.referrer + "oral-history/" + data.link_to_oral_history} target="_blank" className="font-overpass-mono uppercase border border-white text-white p-2 inline-block text-sm cursor-pointer">Listen Now</a>
    </div>
  )
}

export default NewsroomItem;